import { UsersAction, UsersActionTypes, UsersType } from "store/types/users";

const initialState: UsersType = {};

export const users = (state = initialState, action: UsersActionTypes) => {
  switch (action.type) {
    case UsersAction.REPLACE_USERS:
      return action.users;
    case UsersAction.ADD_USER: {
      const group = state[action.groupKey] ?? [];
      return { ...state, [action.groupKey]: [...group, action.user] };
    }
    case UsersAction.UPDATE_USER:
      return Object.fromEntries(
        Object.entries(state).map(([key, group]) => [
          key,
          group.map((u) => (u._id === action.user._id ? action.user : u)),
        ])
      );
    case UsersAction.DELETE_USER:
      return Object.fromEntries(
        Object.entries(state).map(([key, group]) => [
          key,
          group.filter((u) => u._id !== action.userId),
        ])
      );
    default:
      return state;
  }
};
